<template>
  <div>
    <vxe-grid
      auto-resize
      ref="table"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      class="bg-white"
      row-id="resFabricDemandDetailCode"
      :checkbox-config="{
        highlight: true,
        reserve: false,
      }"
      :loading="loading"
      border
    >
      <template v-slot:imageUrl="{ row }">
        <el-image
          class="viewImage"
          :preview-src-list="[row.imageUrl]"
          :src="
            row.thumbImageUrl
              ? $osscdn(row.thumbImageUrl)
              : '/image/static/img/nopic.jpg'
          "
        />
      </template>
      <template v-slot:fabric="{ row }">
        <span>{{ row.fabricNo || '' }}</span>
        <br />
        <span>{{ row.fabricName || '' }}</span>
        <br />
        <span>成分：{{ row.fabricContent || '' }}</span>
      </template>
      <template v-slot:fabricWidWeight="{ row }">
        <span
          >克重：{{ row.fabricWeight || '' }}
          {{ row.fabricWeightUnit || '' }}</span
        >
        <br />
        <span>门幅：{{ row.fabricWid || '' }} {{ row.widUnit || '' }}</span>
      </template>

      <template v-slot:color="{ row }">
        <span>颜色：{{ row.colorName || '' }}</span>
        <br />
        <span>编号：{{ row.ftyColorNo || '' }}</span>
      </template>

      <template v-slot:scm="{ row }">
        <span>{{ row.scmName || '' }}</span>
        <br />
        <span>{{ row.resFabricScmName || '' }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.resFabricDemandStatus === 'P'
              ? 'warning'
              : row.resFabricDemandStatus === 'Y'
              ? 'success'
              : row.resFabricDemandStatus === 'C'
              ? 'danger'
              : ''
          "
          >{{ row.resFabricDemandStatusName }}</el-tag
        >
      </template>

      <template v-slot:qtyPrice="{ row }">
        <span>数量：{{ row.demandQty || '' }}</span>
        <br />
        <span>单价：{{ row.unitPrice || '' }}</span>
      </template>

      <template v-slot:amount="{ row }">
        <span>{{ row.demandAmount || '' }} 元</span>
      </template>

      <template v-slot:demand="{ row }">
        <span>{{ row.resFabricDemandNo || '' }}</span>
        <br />
        <span>{{ row.demandPersonName || '' }}</span>
        <br />
        <span>{{ row.demandDate || '' }}</span>
      </template>
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    tablePage: {
      default: null,
      type: Object,
    },
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  data() {
    return {
      allChecked: false,
      indeterminate: false,
      selected: [],
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
          fixed: 'left',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          title: this.$l('table_label_img') || '图片',
          field: 'thumbImageUrl',
          minWidth: 110,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'imageUrl' },
        },
        {
          title: this.$l('table_label_fabric') || '面料',
          field: 'fabric',
          minWidth: 200,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'fabric' },
        },
        {
          title: this.$l('table_label_fabric_wid_weight') || '克重/门幅',
          field: 'fabricWidWeight',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'fabricWidWeight' },
        },
        {
          title: this.$l('table_label_color') || '颜色',
          field: 'color',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'color' },
        },
        {
          title: this.$l('table_label_scm') || '面料工厂',
          field: 'scm',
          minWidth: 170,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'scm' },
        },
        {
          title: this.$l('table_label_status') || '状态',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'status' },
        },
        {
          title: this.$l('table_label_qty_price') || '数量单价',
          field: 'qtyPrice',
          minWidth: 120,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'qtyPrice' },
        },
        {
          title: this.$l('table_label_amount') || '金额',
          field: 'amount',
          minWidth: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'amount' },
        },
        {
          title: this.$l('table_label_demand') || '需求单号',
          field: 'demand',
          minWidth: 170,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'demand' },
        },
      ],
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 130
    },
    choiceData() {
      return this.getCheckboxRecords()
    },

    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      return data
    },
  },
}
</script>
<style lang="scss" scoped>
.viewImage {
  width: 100px;
  height: 80px;
}
</style>
